import React from "react";
import StateTag from "Components/state-tag";
import { formatDate, sort } from "Utils";
import OperationsColumn from "./operations-column";
import { Table, Tag } from "antd";
import Highlighter from "react-highlight-words";

export default function UsersTable({
  data,
  IsAuthorized,
  loading,
  filteredValue,
  onSetFilteredValue,
  onOperationExecuted,
  ...props
}) {
  const columns = [
    {
      title: "Ad Soyad",
      dataIndex: "name",
      key: "name",
      render: (text, record) => {
        return filteredValue.fastSearchParam?.length > 0 ? (
          <Highlighter
            highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
            searchWords={[filteredValue.fastSearchParam || ""]}
            autoEscape
            textToHighlight={record.name + " " + record.surname}
          />
        ) : (
          record.name + " " + record.surname
        );
      },
      sorter: (a, b) =>
        sort(a.name + " " + a.surname, b.name + " " + b.surname),
    },
    {
      title: "E-Posta",
      dataIndex: ["email"],
      key: "email",
      render: (text, record) => (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[filteredValue.fastSearchParam || ""]}
          autoEscape
          textToHighlight={record.email}
        />
      ),
      sorter: (a, b) => sort(a.email, b.email),
    },
    {
      title: "Grubu",
      sorter: true,
      dataIndex: ["usergroup", "name"],
      render: (text, record) => (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[filteredValue.fastSearchParam || ""]}
          autoEscape
          textToHighlight={record.usergroup?.name}
        />
      ),
      sorter: (a, b) => sort(a.usergroup.name, b.usergroup.name),
    },
    {
      title: "Yaratma Tarihi",
      sorter: true,
      dataIndex: "createdAt",
      sorter: (a, b) => sort(a.createdAt, b.createdAt),
      render: (text, record) => {
        return formatDate(record.createdAt);
      },
    },
    {
      title: "Durum",
      render: (text, record) => {
        return (
          <>
            {record.locked ? <Tag color="blue">Kilitli</Tag> : null}
            <Tag color={record.confirmed ? "green" : "orange"}>
              {record.confirmed ? "Onaylı" : "Onay Bekliyor"}
            </Tag>
            <StateTag state={record?.state} />
          </>
        );
      },
    },
    {
      title: "İşlemler",
      width: 90,
      fixed: "right",
      dataIndex: "operation",
      render: (text, record) => (
        <OperationsColumn
          record={record}
          onOperationExecuted={onOperationExecuted}
        />
      ),
    },
  ];

  return (
    <Table
      style={{ margin: "0 24px" }}
      rowKey={(row) => row.id}
      loading={loading}
      dataSource={data}
      columns={columns}
      pagination={{
        pageSize: 20,
        total: data.length,
        showSizeChanger: false,
        showTotal: (total, range) => {
          return `Toplam ${total} sonuçtan ${range.join(
            "-"
          )} arası gösteriliyor.`;
        },
      }}
      locale={{
        filterConfirm: "Filtrele",
        filterReset: "Temizle",
        emptyText: IsAuthorized
          ? "Kayıt Bulunamadı"
          : "Bu işlem için yetkiniz yok. Sistem yöneticiniz ile iletişime geçebilirsiniz.",
      }}
      size="small"
      bordered
      showSorterTooltip={false}
      scroll={{ x: 1000, scrollToFirstRowOnChange: true }}
    />
  );
}
